export const mainColor = '#28086e';
export const smallFontSize = '12px';
export const bigFontSize = '14px';
export const biggerFontSize = '16px';
